import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import type { Variants } from '../../common/variant/variant';
import { ComponentVariant } from '../../common/variant/variant';

@Component({
  selector: 'rt-dialog-body',
  templateUrl: './dialog-body.component.html',
  styleUrls: ['./dialog-body.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'variant',
  },
  standalone: true,
})
export class DialogBodyComponent {
  public static readonly VARIANTS: Variants = ['default', ['white', 'default', 'no-padding']];
  @ComponentVariant(DialogBodyComponent.VARIANTS)
  @Input()
  public variant: string;
}
